import * as React from 'react';
import { Component } from 'react';
// SENTRY
import * as Sentry from '@sentry/browser';
// REDUX
import { store } from 'redux/store';
// THUNKS
import { fetchSavedSearches } from 'redux/actions/thunks/SavedSearchesThunks';
import { fetchFavorites } from 'redux/actions/thunks/FavoritesThunks';
// COMPONENTS
import AppAuth from 'AppAuth'; // used for verifying app authentication
import AppStore from 'fetch/AppFetch';
import AppLayout from 'AppLayout';
import AppConfig from 'appConfig';
// LIBS
import { heapIdentify } from 'lib/heapHelpers';
import Helper from 'lib/Helper';
// Constants
import { USER_TYPE_ZYWAVE, LOGGED_IN_STATE } from 'lib/config/appConstants';

/**
 * Main app class, sets up the router for different pages in the App
 */
class AppWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedInState: LOGGED_IN_STATE.UNKNOWN,
    };
    // Initialize data to login to the service
    this.initializeData();
  }

  /**
   * Called before the component is mounted, used to login to the service
   */
  initializeData() {
    AppAuth.getUserInfo()
      .then(() => {
        // Clear redirect tracking on successful authentication (only if feature is enabled)
        if (AppConfig.enableRedirectZywaveDotCom) {
          AppAuth.clearRedirectTracking();
        }

        this.setState({
          loggedInState: LOGGED_IN_STATE.LOGGED_IN,
        });
        // Fetch all saved searches
        store.dispatch(fetchSavedSearches()).then(() => {
          // Fetch all available Favorites
          store.dispatch(fetchFavorites());
        });
      })
      .catch(() => {
        this.setState({
          loggedInState: LOGGED_IN_STATE.LOGGED_OUT,
        });
      });
  }

  componentDidMount() {
    const userinfo = AppStore.fetchUserInfo();

    //identify the user to sentry.io for error reporting
    if (Sentry && userinfo) {
      Sentry.setUser(Helper.getSentryUserContext(userinfo));
    }

    if (userinfo) {
      heapIdentify(userinfo);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.loggedInState !== this.state.loggedInState) {
      if (this.state.loggedInState === LOGGED_IN_STATE.LOGGED_OUT) {
        AppStore.deleteZywaveUserFeatureAgencies();
      } else if (this.state.loggedInState === LOGGED_IN_STATE.LOGGED_IN) {
        const userinfo = AppStore.fetchUserInfo();

        if (userinfo?.account_type === USER_TYPE_ZYWAVE) {
          // Setup timer to fetch Zywave User information
          setTimeout(() => {
            AppAuth.getZywaveFeatureLicenseAgencies()
              .then((json) => {
                AppStore.storeZywaveUserFeatureAgencies(json);
              })
              .catch(() => {});
          }, 4000);
        }
      }
    }
  }

  render() {
    if (this.state.loggedInState === LOGGED_IN_STATE.UNKNOWN) {
      return <div />;
    }

    return <AppLayout />;
  }
}

export default AppWrapper;
